import { render, staticRenderFns } from "./bulle-question.vue?vue&type=template&id=197a1ba1&"
import script from "./bulle-question.vue?vue&type=script&lang=js&"
export * from "./bulle-question.vue?vue&type=script&lang=js&"
import style0 from "./bulle-question.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports